import { render, staticRenderFns } from "./PricingPlanos.vue?vue&type=template&id=55a42862"
import script from "./PricingPlanos.vue?vue&type=script&lang=js"
export * from "./PricingPlanos.vue?vue&type=script&lang=js"
import style0 from "./PricingPlanos.vue?vue&type=style&index=0&id=55a42862&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports